export default {"src":"/_next/static/media/files.116bd025.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};